module.exports = __webpack_public_path__ + "img/MoDesk6.cf03f2f3.png";